import { keys } from "@menu/core/constants";
import { CachedItem } from "@lib-shared/lib";

type Inbox = {
    display: boolean,
    unread: number,
    url: string
}

export const defaultInbox = {
    display: false,
    unread: 0,
    url: ""
}

export const sampleInbox = {
    display: true,
    unread: 10,
    url: "#"
}

export const inboxCache = CachedItem.withoutPrefix(keys.inboxData);

export default Inbox;